import { QuantitySelectorComponent } from '@theme/component-quantity-selector';
import { QuantitySelectorUpdateEvent } from '@theme/events';

export class CartQuantitySelectorComponent extends QuantitySelectorComponent {
  isMeterItem() {
    const { quantityInput } = this.refs;
    return quantityInput.step === '0.1';
  }

  getNumber(value, fallback = 0) {
    const number = parseFloat(value);
    return Number.isNaN(number) ? fallback : number;
  }

  getCurrentValues() {
    const { quantityInput } = this.refs;

    if (!this.isMeterItem()) {
      return super.getCurrentValues();
    }

    return {
      min: this.getNumber(quantityInput.min, 0.1),
      max: quantityInput.max ? this.getNumber(quantityInput.max, null) : null,
      step: this.getNumber(quantityInput.step, 0.1),
      value: this.getNumber(quantityInput.value, 0.1),
      cartQuantity: this.getNumber(quantityInput.getAttribute('data-cart-quantity'), 0),
    };
  }

  getEffectiveMax() {
    const { max } = this.getCurrentValues();
    return max;
  }

  updateQuantity(stepMultiplier) {
    if (!this.isMeterItem()) {
      return super.updateQuantity(stepMultiplier);
    }

    const { quantityInput } = this.refs;
    const { min, step, value } = this.getCurrentValues();
    const effectiveMax = this.getEffectiveMax();

    let newValue = value + step * stepMultiplier;
    newValue = Math.min(effectiveMax ?? Infinity, Math.max(min, newValue));

    quantityInput.value = newValue.toFixed(1);

    this.onQuantityChange();
    this.updateButtonStates();
  }

  setQuantity(event) {
    if (!this.isMeterItem()) {
      return super.setQuantity(event);
    }

    if (!(event.target instanceof HTMLInputElement)) return;

    event.preventDefault();

    const { quantityInput } = this.refs;
    const { min, step } = this.getCurrentValues();
    const effectiveMax = this.getEffectiveMax();

    let quantity = this.getNumber(event.target.value, min);
    quantity = Math.min(effectiveMax ?? Infinity, Math.max(min, quantity));

    const rounded = Math.round(quantity / step) * step;
    quantityInput.value = rounded.toFixed(1);

    this.onQuantityChange();
    this.updateButtonStates();
  }

  onQuantityChange() {
    const { quantityInput } = this.refs;

    if (!this.isMeterItem()) {
      return super.onQuantityChange();
    }

    const meterValue = this.getNumber(quantityInput.value, 0);
    const shopifyQuantity = Math.round(meterValue * 10);

    this.dispatchEvent(
      new QuantitySelectorUpdateEvent(
        shopifyQuantity,
        Number(quantityInput.dataset.cartLine) || undefined
      )
    );
  }

  updateButtonStates() {
    const { minusButton, plusButton } = this.refs;
    const { min, value } = this.getCurrentValues();
    const effectiveMax = this.getEffectiveMax();

    minusButton.disabled = value <= min;
    plusButton.disabled = effectiveMax !== null && value >= effectiveMax;
  }
}

if (!customElements.get('cart-quantity-selector-component')) {
  customElements.define('cart-quantity-selector-component', CartQuantitySelectorComponent);
}